import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LicenceStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-licence-status',
  templateUrl: './licence-status.component.html',
  styleUrls: ['./licence-status.component.scss'],
})
export class LicenceStatusComponent implements OnInit {
  licencestatusForm: FormGroup;
  licencestatusFormArray: FormGroup;
  control = new FormControl();
  @Input() licencestatuss: LicenceStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() licencestatus = new EventEmitter<LicenceStatusDto[]>();
  @Output() deleteLicenceStatusEvent = new EventEmitter<any>();

  selectedLicenceStatus: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.createLicenceStatusForm();
  }

  createLicenceStatusForm() {
    this.licencestatusForm = this.fb.group({
      LicenceStatusName: ['', Validators.required],
      id: null,
    });
    this.licencestatusFormArray = this.fb.group({
      LicenceStatuss: this.fb.array([]),
    });
    this.setLicenceStatus();
  }

  // method to display licencestatuss
  setLicenceStatus() {
    const control = this.licencestatusFormArray.controls
      .LicenceStatuss as FormArray;
    this.licencestatuss.forEach((e) => {
      control.push(
        this.fb.group({
          LicenceStatusName: e.LicenceStatusName,
          id: e.id,
        })
      );
    });
  }

  // method to add LicenceStatus
  addLicenceStatus(value: LicenceStatusDto) {
    const control = this.licencestatusFormArray.controls
      .LicenceStatuss as FormArray;
    control.insert(
      0,
      this.fb.group({
        LicenceStatusName: value.LicenceStatusName,
        id: null,
      })
    );
  }

  selectLicenceStatus(value) {}

  // method to delete licencestatus from arrary list
  deleteLicenceStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.licencestatusFormArray.controls
          .LicenceStatuss as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.licencestatuss.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.licencestatuss[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: LicenceStatusDto) {
    if (this.licencestatusForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.licencestatusFormArray
        .get('LicenceStatuss')
        ['controls'][this.selectedIndex].patchValue({
          LicenceStatusName: formValue.LicenceStatusName,
        });
    } else {
      this.addLicenceStatus(formValue);
    }
    this.selectedIndex = null;
    this.licencestatusForm.reset();
  }

  onEdit(index, value: LicenceStatusDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.licencestatusForm.patchValue({
      LicenceStatusName: value.LicenceStatusName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.licencestatusForm.reset();
  }

  onSubmit(formValue: LicenceStatusDto[]) {
    this.licencestatus.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteLicenceStatusEvent.emit(this.filteredDelete);
    }
  }
}
